import { takeLatest, put, call } from "redux-saga/effects";
import { UnautherizedResponse } from "../GetUser/GetUserActions";
import ACTIONS from "./SettingsActionTypes";
import { axiosPost, axiosPut, axiosGet } from "../../Utils/axios";
import {
  getCustomRoleByPermissionResponse,
  getCustomRoleListResponse,
  getSettingsResponse,
  postCustomRoleResponse,
  postSettingsResponse,
  putCustomRoleByPermissionResponse,
  putCustomRoleResponse,
  putCustomRoleStatusResponse,
  putSettingsResponse,
} from "./SettingsActions";

//OTHER SETTINGS
export function* onGetSettingsHelperSaga() {
  try {
    let response = yield call(() =>
      axiosGet(`settings/other_settings`).then((res) => res?.data)
    );
    yield put(getSettingsResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onPutSettingsHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosPut(`settings/other_settings/${payload._id}`, payload).then(
        (res) => res?.data
      )
    );
    yield put(putSettingsResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onPostSettingsHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosPost(`settings/other_settings/new`, payload).then((res) => res?.data)
    );
    yield put(postSettingsResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

//CUSTOM ROLES

export function* onGetCustomRolesHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosPost("settings/custom_role/index", payload).then((res) => res?.data)
    );
    yield put(getCustomRoleListResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onPutCustomRolesHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosPut(`settings/custom_role/${payload._id}`, payload).then(
        (res) => res?.data
      )
    );
    yield put(putCustomRoleResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onPutCustomRolesStatusHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosPut(`settings/custom_role/status/${payload._id}`, payload).then(
        (res) => res?.data
      )
    );
    yield put(putCustomRoleStatusResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onPostCustomRoleHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosPost(`settings/custom_role/new`, payload).then((res) => res?.data)
    );
    yield put(postCustomRoleResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onGetRoleByPermissionHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosGet(`settings/custom_role/role_by_permission/${payload?._id}`).then(
        (res) => res?.data
      )
    );
    yield put(getCustomRoleByPermissionResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* onPutRoleByPermissionHelperSaga({ payload }) {
  try {
    const response = yield call(() =>
      axiosPut(
        `settings/custom_role/role_by_permission/${payload._id}`,
        payload
      ).then((res) => res?.data)
    );
    yield put(putCustomRoleByPermissionResponse(response));
  } catch (error) {
    yield put(UnautherizedResponse(error));
  }
}

export function* SettingsWatcherSaga() {
  //OTHER SETTINGS
  yield takeLatest(ACTIONS.GET_SETTINGS_REQUEST, onGetSettingsHelperSaga);
  yield takeLatest(ACTIONS.POST_SETTINGS_REQUEST, onPostSettingsHelperSaga);
  yield takeLatest(ACTIONS.PUT_SETTINGS_REQUEST, onPutSettingsHelperSaga);
  //CUSTOM ROLES
  yield takeLatest(
    ACTIONS.GET_CUSTOM_ROLE_LIST_REQUEST,
    onGetCustomRolesHelperSaga
  );
  yield takeLatest(
    ACTIONS.POST_CUSTOM_ROLE_REQUEST,
    onPostCustomRoleHelperSaga
  );
  yield takeLatest(ACTIONS.PUT_CUSTOM_ROLE_REQUEST, onPutCustomRolesHelperSaga);
  yield takeLatest(
    ACTIONS.PUT_CUSTOM_ROLE_STATUS_REQUEST,
    onPutCustomRolesStatusHelperSaga
  );
  yield takeLatest(
    ACTIONS.GET_ROLE_BY_PERMISSION_REQUEST,
    onGetRoleByPermissionHelperSaga
  );
  yield takeLatest(
    ACTIONS.PUT_ROLE_BY_PERMISSION_REQUEST,
    onPutRoleByPermissionHelperSaga
  );
}
